<template>
  <div class="master-editor">

    <div v-if="loading" class="nz-loading">Loading…</div>
    <div v-else-if="error" class="error-msg">{{ error }}</div>

    <div v-else>

      <h3><span class="icon-tag"></span> Duplicate Article - {{ article.label }}</h3>

      <!-- ===========================
           INFO
      ============================== -->
      <ul class="info-list">
        <li class="info-item">Article Properties</li>
        <li class="info-item">Bricks (Content Elements)</li>
        <li class="info-item">Image Galleries</li>
        <li class="info-item">Uploaded Files (Copied and linked afresh)
        </li>
      </ul>

    </div>

    <!-- ===========================
         FOOTER
    ============================== -->
    <div class="nz-modal-footer">
      <button
        class="btn btn-warning"
        @click="cancel"
        :disabled="working"
      >
        Cancel
      </button>

      <button
        class="btn btn-primary"
        @click="duplicate"
        :disabled="working"
      >
        <span v-if="working">Duplicating…</span>
        <span v-else>Duplicate Article</span>
      </button>
    </div>

  </div>
</template>

<script setup>
import { ref, onMounted, defineExpose } from "vue";

const props = defineProps({
  article: { type: Object, required: true }
});

const emit = defineEmits(["close"]);

/* ===============================
   STATE
=============================== */
const loading = ref(true);
const working = ref(false);
const error = ref(null);

// customer_id resolved once
const customerId = ref(
  localStorage.getItem("customer_id") || "1"
);

/* Expose to modal manager */
defineExpose({ working });

/* ===============================
   LOAD (lightweight)
=============================== */
function load() {
  loading.value = false;
}

/* ===============================
   DUPLICATE
=============================== */
async function duplicate() {
  working.value = true;
  error.value = null;

  try {
    const apiKey = localStorage.getItem("api_key");

    const res = await fetch(
      `/api/articles/${props.article.id}/duplicate`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(apiKey ? { "x-api-key": apiKey } : {})
        },
        body: JSON.stringify({
          customer_id: customerId.value
        })
      }
    );

    if (!res.ok) {
      throw new Error("Duplicate failed");
    }

    const json = await res.json();

    emit("close", {
      duplicated: true,
      newArticleId: json.data?.id
    });

  } catch (err) {
    console.error("Failed to duplicate article:", err);
    error.value = "Failed to duplicate article.";
  } finally {
    working.value = false;
  }
}

/* ===============================
   CANCEL
=============================== */
function cancel() {
  emit("close", false);
}

/* ===============================
   MOUNT
=============================== */
onMounted(load);
</script>

<style scoped>
.error-msg {
  color: red;
  padding: 10px;
}

.nz-select {
  width: 100%;
  padding: 6px;
  margin-bottom: 10px;
}
</style>
